export const ResponseStatus = {
    OK: 200,
    INTERNAL_SERVER_ERR: 500,
    UNAUTHORIZED: 401 
  };
  